(ns nl.mediquest.questionnaire-frontend.component.report.email
  (:require
   [email-validator :rename {validate valid-email?}]
   [nl.mediquest.questionnaire-frontend.component.i18n :as i18n]
   [nl.mediquest.questionnaire-frontend.events :as events]
   [nl.mediquest.ui.core.modal :as modal]
   [re-frame.core :as re-frame]
   [reagent.core :as r]))

(defn- email-validation-text [email-address]
  (and (seq email-address)
       (not (valid-email? email-address))
       [:div.text-red-600.ml-2
        [i18n/text :report/email_1]]))

(defn- handle-submit-email-fn [email-address]
  (fn [event]
    (.preventDefault event)
    (when (valid-email? email-address)
      (re-frame/dispatch [::events/email-report email-address]))))

(defn- email-input-label []
  [:label
   {:for "email-address"
    :class "block font-bold md:text-right mb-1 md:mb-0 pr-4"}
   [i18n/text :report/email_2]])

(defn- email-input [email-address]
  [:input
   {:size 25
    :autoFocus true
    :class "bg-gray-200 appearance-none border-2
           border-gray-200 rounded w-full py-2 px-4 text-gray-700
           leading-tight focus:outline-none focus:bg-white
           focus:border-gray-700"
    :id "email-address"
    :placeholder (i18n/text :report/email_3)
    :value @email-address
    :on-change #(reset! email-address (.. % -target -value))
    :type "email"}])

(defn- submit-email-button [email-address]
  [:button {:class "button shadow bg-primary bg-mq-primary focus:shadow-outline
                   focus:outline-none text-white font-bold py-2 px-4
                   rounded"
            :type "submit"
            :disabled (not (valid-email? email-address))}
   [i18n/text :report/email_4]])

(defn- col [fraction & components]
  (apply conj
         [:div
          {:class (str "md:w-" fraction " md:align-content")}]
         components))

(defn row [col & cols]
  (apply conj
         [:div {:class "md:flex md:items-center mb-2"}]
         col
         cols))

(defn email-report-form []
  (let [email-address (r/atom "")]
    (fn []
      [:form.bg-white
       {:on-submit (handle-submit-email-fn @email-address)}
       [row [col "1/3" [email-input-label]]
            [col "2/3"
                 [email-input email-address]
                 [email-validation-text @email-address]]]
       [row [col "1/3"]
            [col "2/3" [submit-email-button @email-address]]]
       [row [col "1/3"]
            [col "2/3"
                 [i18n/text :report/email_5]]]])))

(defn email-button []
  [:button.button.button--large.mr-3
   {:on-click #(modal/open! email-report-form)}
   [i18n/text :report/email]])
